export default "__VITE_ASSET__DwY4P3u5__"